const getters = {
  footerData: state => state.footer.info
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js